import { render, staticRenderFns } from "./RichTextQuestion.vue?vue&type=template&id=310f0430&scoped=true&"
import script from "./RichTextQuestion.vue?vue&type=script&lang=ts&"
export * from "./RichTextQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310f0430",
  null
  
)

export default component.exports